var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import "./list";
import "./detail";
import "./edit";
import "./tuigrid.css";
import styled from "@emotion/styled";
// Header menu style
export var SimpleMenu = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  z-index: 99999;\n  width: 175px;\n  padding: 8px 0;\n  border-radius: 6px;\n  box-shadow: 0px 0px 1px rgba(62, 65, 86, 0.7),\n    0px 6px 12px rgba(62, 65, 86, 0.35);\n\n  display: flex;\n  flex-direction: column;\n\n  background-color: white;\n  font-size: 13px;\n  font-weight: 600;\n\n  > div {\n    padding: 6px 8px;\n    color: rgba(0, 0, 0, 0.7);\n    :hover {\n      background-color: rgba(0, 0, 0, 0.05);\n      color: rgba(0, 0, 0, 0.9);\n    }\n    transition: background-color 100ms;\n    cursor: pointer;\n  }\n"], ["\n  z-index: 99999;\n  width: 175px;\n  padding: 8px 0;\n  border-radius: 6px;\n  box-shadow: 0px 0px 1px rgba(62, 65, 86, 0.7),\n    0px 6px 12px rgba(62, 65, 86, 0.35);\n\n  display: flex;\n  flex-direction: column;\n\n  background-color: white;\n  font-size: 13px;\n  font-weight: 600;\n\n  > div {\n    padding: 6px 8px;\n    color: rgba(0, 0, 0, 0.7);\n    :hover {\n      background-color: rgba(0, 0, 0, 0.05);\n      color: rgba(0, 0, 0, 0.9);\n    }\n    transition: background-color 100ms;\n    cursor: pointer;\n  }\n"])));
export var tableOptions = {
    outline: {
        border: "none",
    },
    selection: {},
    row: {
        odd: {
            background: "var(--colors-bg-default)",
        },
        even: {
            background: "var(--colors-bg-neutral)",
        },
    },
    cell: {
        header: {
            background: "var(--colors-bg-default)",
            border: "var(--colors-bg-neutral)",
            //text: "var(--colors-label)",
            text: "black",
            font: "bold",
        },
        focused: {
            background: "none",
        },
        selectedHeader: {
            background: "none",
        },
        normal: {
            border: "var(--colors-bg-neutral)",
        },
        focusedInactive: {},
        rowHeader: {
            border: "none",
        },
    },
};
/**
 * Extract fieldNames from layoutMeta
 * @param obj
 * @returns
 */
export var extractFieldNames = function (obj) {
    var fieldNames = [];
    for (var key in obj) {
        if (key === "field") {
            fieldNames.push(obj[key]);
        }
        else if (typeof obj[key] === "object") {
            fieldNames = fieldNames.concat(extractFieldNames(obj[key]));
        }
    }
    return fieldNames;
};
/**
 * Mapping fieldName
 * @param meta
 * @param fieldDefs
 * @returns
 */
export var mapFieldMetaData = function (meta, fieldDefs) {
    var fieldNames = extractFieldNames(meta);
    var filteredFieldsDefs = Object.fromEntries(Object.entries(fieldDefs).filter(function (_a) {
        var key = _a[0];
        return fieldNames.includes(key);
    }));
    var fieldMetadataMap = new Map();
    // Iterate over the object keys and set them as entries in the Map
    for (var key in filteredFieldsDefs) {
        if (filteredFieldsDefs.hasOwnProperty(key)) {
            fieldMetadataMap.set(key, filteredFieldsDefs[key]);
        }
    }
    return [filteredFieldsDefs, fieldMetadataMap];
};
var templateObject_1;
